<template>
    <main-content>
        <kt-panel>
            <kt-panel-body v-if="status === 'success'">
                <div>
                    <kt-row lg="12" md="12" sm="12" :class="varient()">
                        <kt-col lg="6" md="6" sm="6">
                            <li>
                                {{ rechargeResultData.message }}
                            </li>
                        </kt-col>
                    </kt-row>
                </div>
            </kt-panel-body>
            <loader v-else></loader>
        </kt-panel>
    </main-content>
</template>

<script>
import {mapGetters} from "vuex";
import mainContent from '@/components/main-content'
import Loading from '@/components/custom/loading'

export default {
    name: "Checkout",

    components: {
        'main-content': mainContent,
        'loader': Loading
    },
    computed: {
        ...mapGetters('notificationSms', [
            'rechargeResultData',
            'status'
        ]),
    },

    data() {
        return {
            tracking_code: this.$route.params.tracking_code
        }
    },
    methods: {
        varient() {
            if (this.rechargeResultData.payment_succeed === true)
                return 'success'
            else
                return 'danger'
        }
    },
    mounted() {
        this.$store.dispatch('notificationSms/rechargeData', this.tracking_code)
    },
}
</script>

<style scoped>
.success {
    color: #00bea5;
}
.danger {
    color: red;
}
</style>